import React, { useState, useEffect } from "react";
import swal from "sweetalert";
import dayjs from "dayjs";

import { Button } from "../../elements/Button";
import buttoncss from "../../css/button.module.css";
import icrCss from "../../css/interCompanyEliminations.module.css";
import { ReactComponent as PlusPrimary } from "../../assets/icons/primary_plus.svg";
import { ReactComponent as EditIcon } from "../../assets/icons/edit.svg";
import CreateEntryModal from "./CreateEntryModal";
import { getAllInterCompanyEliminationsApiHandler } from "../../../WorkSpace/Components/ApiServices/apiHandler";
import CreateEditEntryModal from "./CreateEditEntryModal";
import Breadcrumb from "../Breadcrumb";

const InterCompanyEliminationsEntries = ({
  setEliminationScreen,
  history,
  consolID,
  workspaceName,
  consolName,
  workspaceID
}) => {
  const [interCompanyEliminations, setInterCompanyEliminations] = useState([]);
  const [entryModal, setEntryModal] = useState(false);
  const [selectedEntry, setSelectedEntry] = useState(null);

  const closeEntryModal = () => {
    setEntryModal(false);
    setSelectedEntry(null);
  };

  useEffect(() => {
    getInterCompanyEliminations();
  }, []);

  const getInterCompanyEliminations = (cat) => {
    const getParams = {
      category: cat,
      consolID: consolID,
    };
    getAllInterCompanyEliminationsApiHandler(getParams)
      .then((response) => {
        if (response?.data?.success === true) {
          const eliminationsData = response?.data;

          setInterCompanyEliminations(
            eliminationsData?.intercompanyEliminations ?? [],
          );
        } else {
          setInterCompanyEliminations([]);
          swal(
            "Error",
            response?.data?.error || "Unable to get inter company eliminations",
            "error",
          );
        }
      })
      .catch((error) => {
        setInterCompanyEliminations([]);
        swal(
          "Error",
          error?.response?.data?.error ||
            "Unable to populate inter company eliminations",
          "error",
        );
      });
  };

  return (
    <>
      <div className={icrCss.header} style={{ justifyContent: "space-between", gap: "10px", padding: "10px 0px 0px 0px" }}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <Breadcrumb
            addCls="bgTransprent"
            p0={true}
            items={[
              { label: workspaceName || "Workspace", link: workspaceID ? `/consolidation/${workspaceID}` : `/myfinV2/standalonefs`, className: "nav_cnt_color clickable" },
              { label: `${consolName || "Consol"} - Adjustments - Inter company elimination`, link: "", className: "headerLable" },
            ]}
            backLink={workspaceID ? `/consolidation/${workspaceID}` : "/myfinV2/standalonefs"}
          />
        </div>
        <div style={{ display: "flex", gap: "10px" }}>
          <Button
            btnColor={buttoncss.greyBg}
            label="View Workings"
            onClick={() => setEliminationScreen(1)}
          />
          <Button
            btnColor={buttoncss.primary}
            label="Populate FS"
            onClick={() => {
              history.push(`/myfinV2/console-populatefs/${consolID}`);
            }}
          />
        </div>
      </div>
      <div className={icrCss.entrytableCtn} style={{ paddingTop: "5px", paddingLeft: "0px", paddingRight: "0px" }}>
        <table className={icrCss.entrytable}>
          <thead>
            <tr>
              <th className="text-left" style={{paddingLeft: "20px"}}>Particulars</th>
              <th className="text-center" style={{ width: "130px" }}>
                Date
              </th>
               <th style={{ textAlign: "right", paddingRight: "25px" }}>Current year</th>
              <th style={{ textAlign: "right", paddingRight: "20px" , whiteSpace: "noWrap"}}>Previous year</th>

              <th className="text-left" style={{ width: "300px" }}>
                Remarks
              </th>
              <th className="text-center" style={{ width: "55px" }}></th>
            </tr>
          </thead>

          <tbody>
            {interCompanyEliminations.length > 0 &&
              interCompanyEliminations.map((group, groupIndex) => (
                <React.Fragment key={groupIndex}>
                  {group.adjustments.map((row, rowIndex) => (
                    <tr key={`${groupIndex}-${rowIndex}`}>
                      <td className="text-left">{row.levelThree}</td>
                      {rowIndex === 0 && (
                        <td
                          rowSpan={group.adjustments.length}
                          className="text-center"
                        >
                          {group.adjustmentDate
                            ? dayjs(group.adjustmentDate).format("DD-MMM-YYYY")
                            : ""}
                        </td>
                      )}

                      <td className={icrCss.amount}>
                        {row.currentYear !== null && row.currentYear !== undefined
                          ? (() => {
                              const num = Math.round(Number(row.currentYear));
                              if (isNaN(num)) return "";
                              return num < 0
                                ? `(${Math.abs(num).toLocaleString("en-IN")})`
                                : num.toLocaleString("en-IN");
                            })()
                          : ""}
                      </td>

                      <td className={icrCss.amount}>
                        {row.previousYear !== null && row.previousYear !== undefined
                          ? (() => {
                              const num = Math.round(Number(row.previousYear));
                              if (isNaN(num)) return "";
                              return num < 0
                                ? `(${Math.abs(num).toLocaleString("en-IN")})`
                                : num.toLocaleString("en-IN");
                            })()
                          : ""}
                      </td>

                      {rowIndex === 0 && (
                        <td
                          rowSpan={group.adjustments.length}
                          className="text-left"
                        >
                          {group.remarks}
                        </td>
                      )}

                      {rowIndex === 0 && (
                        <td
                          rowSpan={group.adjustments.length}
                          className="text-center"
                          style={{ paddingRight: "17px" }}
                        >
                          <EditIcon
                            height={18}
                            width={18}
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              setSelectedEntry(group);
                              setEntryModal(true);
                            }}
                          />
                        </td>
                      )}
                    </tr>
                  ))}

                  <tr className={icrCss.groupSeparator}>
                    <td colSpan={6}></td>
                  </tr>
                </React.Fragment>
              ))}

            {interCompanyEliminations.length === 0 && (
              <tr>
                <td colSpan={6}>No Adjustment Data</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {entryModal && (
        <CreateEditEntryModal
          consolID={consolID}
          handleClose={closeEntryModal}
          editData={
            selectedEntry
              ? {
                  ...selectedEntry,
                  _id: selectedEntry.iceID || selectedEntry._id,
                }
              : null
          }
          getInterCompanyEliminations={getInterCompanyEliminations}
          type="ice"
        />
      )}
    </>
  );
};

export default InterCompanyEliminationsEntries;
